import { createCommonjsModule, commonjsGlobal, unwrapExports } from '../../../_virtual/_commonjsHelpers.js';
import '../../style-to-object/index.js';
import { __moduleExports as utilities } from './utilities.js';
import require$$0 from '../../../_virtual/index.mjs_commonjs-proxy2.js';

var cjs = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var style_to_object_1 = __importDefault(require$$0);

function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1["default"])(style, function (property, value) {
        if (property && value) {
            output[(0, utilities.camelCase)(property, options)] = value;
        }
    });
    return output;
}
exports["default"] = StyleToJS;
});

unwrapExports(cjs);

export { cjs as __moduleExports };
